'use client';
import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Products', href: '#products' },
  { label: 'Projects', href: '#projects' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setActiveSection(id);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 w-full z-50 transition-all duration-500 ${
          scrolled ? 'bg-white shadow-md' : 'bg-white'
        }`}
        style={{ fontFamily: 'Ubuntu, sans-serif' }}
      >
        <div className="max-w-[1200px] mx-auto px-4 md:px-8 flex items-center justify-between h-[75px]">
          {/* Logo */}
          <a href="#home" onClick={() => handleNavClick('#home')} className="flex items-center gap-3 cursor-pointer">
            <div className="flex items-center gap-2">
              <img
                src="/assets/images/Screenshot_20260806-003009-1785956437897.png"
                alt="Bhargav Engineering Logo"
                className="h-14 w-auto object-contain"
              />
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center">
            <ul className="flex items-center">
              {navLinks.map((link) => (
                <li key={link.label} className="relative group">
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className={`block px-4 py-5 text-[17px] leading-5 tracking-[0.6px] transition-colors duration-300 ${
                      activeSection === link.href.replace('#', '') ? 'text-[#00AAE2]' : 'text-[#231F20] hover:text-[#00AAE2]'
                    }`}
                    style={{ fontFamily: 'Ubuntu, sans-serif' }}
                  >
                    {link.label}
                  </a>
                  {/* Top border indicator on hover */}
                  <span
                    className={`absolute top-0 left-0 right-0 h-[6px] bg-[#00AAE2] transition-transform duration-400 origin-center ${
                      activeSection === link.href.replace('#', '') ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                    style={{ transition: 'transform 0.4s ease' }}
                  />
                </li>
              ))}
            </ul>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
              className="h-[35px] flex items-center justify-center px-5 border border-[#00AAE2] rounded-full text-[#231F20] text-[16px] tracking-[0.6px] hover:bg-[#00AAE2] hover:text-white transition-all duration-300"
              style={{ fontFamily: 'Ubuntu, sans-serif' }}
            >
              Enquire Now
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="lg:hidden flex flex-col gap-1.5 p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span className={`block w-6 h-0.5 bg-[#231F20] transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-0.5 bg-[#231F20] transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-0.5 bg-[#231F20] transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ${
            mobileOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <ul className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="block py-3 text-[16px] text-[#231F20] border-b border-gray-100 hover:text-[#00AAE2] transition-colors"
                  style={{ fontFamily: 'Ubuntu, sans-serif' }}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-3">
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
                className="inline-block px-6 py-2 border border-[#00AAE2] rounded-full text-[#231F20] hover:bg-[#00AAE2] hover:text-white transition-all duration-300"
              >
                Enquire Now
              </a>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
}
